import { createTheme } from '@material-ui/core/styles';

const primaryColor = '#08607e';

export default createTheme({
    palette: {
        primary: {
            main: primaryColor
        },
        secondary: {
            main: primaryColor
        }
    },
    status: {
        danger: 'orange',
    },
    overrides: {
        MuiMenuItem: {
            root: {
                color: '#000000 !important',
                marginLeft: '8px',
                borderRadius: '6px',
                transition: 'all 0.2s ease',
                '&:hover': {
                    backgroundColor: 'rgba(8, 96, 126, 0.1)',
                },
            },
        },

        MuiListItemIcon: {
            root: {
                color: '#495057 !important',
            },
        },

        RaMenuItemLink: {
            root: {
                paddingLeft: '8px',
            },
            active: {
                backgroundColor: `${primaryColor} !important`,
                color: '#ffffff !important',
                '& .MuiListItemIcon-root': {
                    color: '#ffffff !important',
                },
                '& .MuiTypography-root': {
                    color: '#ffffff !important',
                },
            },
        },
    },
});